import { RadioCard } from '@mantine/core'
import classes from './styles.module.css'

export default RadioCard.extend({
    defaultProps: {
        radius: 'var(--gm-radius-4)',
        withBorder: true,
        p: 'var(--gm-spacing-24)',
    },
    classNames: { card: classes.card },
})
